import { reduxKey } from '../../constants';
import { DamzState } from '../../types';

export function getState(state): DamzState {
  return state[reduxKey] ?? {};
}
